import { ChoiceGroup } from "@/components/forms/ChoiceGroup";

type Props = {
  id?: string;
  label: string;
  options: string[];
  value: unknown;
  onChange: (v: string[]) => void;
  error?: string;
};

export function FieldMultiSelect({ id, label, options, value, onChange, error }: Props) {
  const selected = Array.isArray(value) ? (value as string[]) : [];
  return (
    <ChoiceGroup
      id={id ?? `multi-${label.replace(/[^a-zA-Z0-9]+/g, "-")}`}
      multiple
      legend={label}
      options={options.map((opt) => ({ value: opt, label: opt }))}
      value={selected}
      onChange={onChange}
      error={error}
    />
  );
}
